// This file should only contain action type constants.

export const SET_ITEMS = 'SET_ITEMS';
export const SET_SIMPLE_VIEW_ATTRIBUTES = 'SET_SIMPLE_VIEW_ATTRIBUTES';
